import { SemanticCOLORS, SemanticICONS } from 'semantic-ui-react';
import { FieldValueConfirmationType, FieldValueWarningType } from '../../../../types';

export function getInfoPopUpIconProps(
    warnings: FieldValueWarningType[],
    confirmations: FieldValueConfirmationType[]
): { name: SemanticICONS; color: SemanticCOLORS } {
    const iconProps: { name: SemanticICONS; color: SemanticCOLORS } = { name: 'info', color: 'blue' };
    if (warnings.length && confirmations.length) {
        iconProps.name = 'check';
        iconProps.color = 'yellow';
    } else if (warnings.length) {
        iconProps.name = 'info';
        iconProps.color = 'red';
    } else if (confirmations.length) {
        iconProps.name = 'check';
        iconProps.color = 'green';
    }

    return iconProps;
}
